const prefixAlgoForSameCustomer = (algoCode: string, func: any) => {
  const prefix = algoCode.slice(0, 2);
  return prefix === "AO" ? "" : func;
};
export default prefixAlgoForSameCustomer;
